export const portalData = {
    // Fax Details
    hasFax: false,
    faxNo: "",
    
    // Whatsapp details
    hasWhatsApp: true,
    whatsAppNo: "+09-6245500",
    whatsAppNoHolderName: "Tan Li Li",
    hasAltWhatsApp: false,
    altWhatsAppNo: "+09-6665500",
    altWhatsAppNoHolderName: "Tan Wei Jim",
    hasAltWhatsApp1: false,
    altWhatsAppNo1: "",
    altWhatsAppNoHolderName1: "",
    hasAltWhatsApp2: false,
    altWhatsAppNo2: "",
    altWhatsAppNoHolderName2: false,
    
    // Phone number details
    hasPhoneNo: true,
    phoneNo: "+09-6245500",
    hasAltPhoneNo: true,
    altPhoneNo: true,
    
    // Telephone number details
    hasTellNo: true,
    tellNo: "+09-6245500",
    tellNoHolderName: "Tan Li Li",
    hasAltTellNo: true,
    altTellNo: "+09-6665500",
    altTellNoHolderName: "Tan Wei Jim",
    hasAltTellNo2: false,
    altTellNo2: "",
    altTellNoHolderName2: "",
    
    // Portal information details
    portalNameXSpace: "Redang Holiday Beach Resort",
    portalName: "Redang Holiday Beach Resort",
    portalFullName: "Redang Holiday Beach Resort Sdn. Bhd.",
    portalFullNameUppercase: "REDANG HOLIDAY BEACH RESORT SDN. BHD.",
    portalShortAddress: "35 Jalan Bandar",
    portalAddress: "35 Jalan Bandar, 20100 KualaTerengganu",
    portalAddressFirstPart: "35 Jalan Bandar,",
    portalAddressSecondPart: "20100 KualaTerengganu",
    portalAddressDetails: "35 Jalan Bandar, 20100 KualaTerengganu",
    hasPortalRegNo: false,
    portalRegNo: "",
    
    // Portal Bank Details
    portalBankName: "CIMB Bank",
    portalBankAddress: "",
    portalBankAccHolderName: "Redang Holiday Beach Resort Sdn. Bhd.",
    portalBankAccNo: "8006622817",
    hasPortalBankSwiftCode: true,
    portalBankSwiftCode: "CIBBMYKL",   
     
    portalEmail: "redholi@redangholiday.com",
    portalTermAndCondUrl: process.env.REACT_APP_PORTAL_TERM_AND_COND_URL,   
    appName: "Island Resort Centralised Reservation Platform",

    // GST details
    hasGst: false,
    gstNo: true,
     
    // Website
    portalWebsite: process.env.REACT_APP_PORTAL_WEBSITE,
   
    // Travoxis Website
    travoxisWebsite: process.env.REACT_APP_TRAVOXIS_WEBSITE,
   
    // Facebook page link
    facebookMessengerLink: "https://www.facebook.com",
   
    // portal S3 base url
    s3AwsUrl: "",
   
    adminPortalUrl: process.env.REACT_APP_ADMIN_PORTAL_URL,
  
    // Portal Jetty names
    jettyOne: "Merang Jetty",
    jettyTwo: "",
    jettyThree: "",
    jettyOneToTwoTime: "",
    jettyTwoToOneTime: ""
}  